<template>
  <div class="countdown-main" :class="{'countdown-main--fixed': fixed, 'countdown-main--sticky': sticky, 'countdown-main--safe': safe}">
    <span class="left">剩余名额<i>{{courseQuota}}</i>名</span>
    <div class="countdown-wrap layout-flex layout-flex_v--c">
      <span class="text">优惠倒计时</span>
      <span class="num">{{date[0]}}</span>
      <span class="num-space">:</span>
      <span class="num">{{date[1]}}</span>
      <span class="num-space">:</span>
      <span class="num">{{date[2]}}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Counter } from '@/utils/countDown.js';
export default {
  props: {
    format: {
      type: Array,
      default: () => []
    },
    fixed: {
      type: Boolean,
      default: false
    },
    sticky: {
      type: Boolean,
      default: false
    },
    // 是否开启底部安全距离
    safe: {
      type: Boolean,
      default: false
    },
    during: {
      type: [String, Number],
      default: 0,
    },
    timeLeft: {
      type: [String, Number],
      default: 0,
    }
  },
  data() {
    return {
      date: ['00', '00', '00'],
      Counter: null,
    };
  },
  watch: {
    during: {
      handler(val) {
        this.begin();
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('course', ['courseQuota']),
  },
  created() {

  },
  methods: {
    begin(d) {
      !this.Counter && (this.Counter = new Counter());
      this.Counter.countStop();
      const during = d || this.timeLeft;
      // 领取倒计时
      this.Counter.countBegin({ during, format: this.format }, (res) => {
        this.date = res;
      }, (res) => {
        this.begin(this.during);
      });
    }
  },
  beforeDestroy() {
    this.Counter && this.Counter.countStop();
    this.Counter = null;
  }
};
</script>

<style scoped lang="stylus">
.countdown-main {
  width 100%
  font-family: PingFangSC-Regular, PingFang SC;
  height 38px;
  background-image url('./images/count_down@2x.png');
  background-size 100% 38px;
  box-sizing border-box;
  display flex;
  justify-content space-between;
  align-items center;
  font-size 12px;
  &.countdown-main--fixed{
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0.64rem;
  }
  &.countdown-main--sticky{
    position: sticky;
    top: 0;
  }
  &.countdown-main--safe {
    bottom: calc(64px + constant(safe-area-inset-bottom));
    bottom: calc(64px + env(safe-area-inset-bottom));
  }

  .left {
    color #fff;
    margin-left 16px;
    font-weight: bold;
    i {
      font-style normal;
      font-size 18px;
      margin 0 5px;
    }
  }

  .countdown-wrap {
    margin-right: 12px;
    .text {
      color #FF6231;
      font-weight: bold;
    }
    .num {
      width: 18px;
      height: 20px;
      margin: 0 4px;
      text-align center;
      line-height 20px;
      font-size: 14px;
      font-family: Oswald-Medium, Oswald;
      font-weight: 500;
      color: #FFFFFF;
      background: linear-gradient(138deg, #FF9270 0%, #FF5F2E 100%);
      border-radius: 2px;
    }
    .num-space {
      color: #FF5F2E;
    }
  }
}
</style>